module.exports = __webpack_public_path__ + "static/media/groupHand.8361c7e9.png";